// Single source of truth for the send (paper-plane) icon geometry — web's
// SendIcon (DOM svg) and mobile's SendIcon (react-native-svg) both trace it.
export const SEND_ICON = {
  viewBox: '0 0 20 20',
  strokeWidth: 1.66667,
  paths: [
    'M18.3337 1.66675L9.16699 10.8334',
    'M18.3337 1.66675L12.5003 18.3334L9.16699 10.8334L1.66699 7.50008L18.3337 1.66675Z',
  ],
} as const;
